<div class="">
  <div class="row col-12 rr-container-white">
    <div class="ml-3">
      <h5 class="pb-4">
        <span *ngIf="!isBulkEdit">
          <i class="fas fa-table px-2"></i> Data Entry
        </span>

        <span *ngIf="isBulkEdit">
          <i class="fas fa-list-alt px-2"></i> Bulk Edit -
          <span class="pl-1 text-muted"><em>Run Tickets</em></span>
        </span>
      </h5>
    </div>
    <!--<div class="col-6">
      <div class="mt-4 " *ngIf="isLoadingField; else notLoadingField">
        <app-loading-indicator [medium]="true"></app-loading-indicator>
      </div>

      <ng-template #notLoadingField>
        <ng-container *ngIf="!field || errorField; else noFieldError">
          <div class="text-danger mt-4">
            <strong>{{errorField}}</strong>
          </div>
        </ng-container>
        <ng-template #noFieldError>
          <h4 class="field-name">
            {{field.fieldName | titlecase}}
            <button class="ml-2 badge badge-pill badge-outline-secondary" style="font-size: .8rem" routerLink="/app/Portal/dataentry">
              Change field
            </button>
          </h4>
        </ng-template>
      </ng-template>
    </div>-->
  </div>

  <!--<div class="d-flex flex-column flex-md-row ml-4">
    <h6 class="m-2 pt-2">Run Tickets</h6>
  </div>

  <div *ngIf="!entryDate; else ticketLevel">
  <div class="col-12">
    <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-between align-items-center ml-3 pb-3">
      <div class="d-flex flex-wrap flex-column flex-sm-row align-items-center">
        <div class="btn-group" role="button">
          <button class="btn fw-700" type="button" (click)="changeTicketView('daily')" [class.btn-primary]="ticketView == 'daily'" [class.btn-outline-secondary]="ticketView != 'daily'">
            Daily
          </button>
          <button class="btn fw-700" type="button" (click)="changeTicketView('bulk')" [class.btn-primary]="ticketView == 'bulk'" [class.btn-outline-secondary]="ticketView != 'bulk'">Bulk Edit</button>
        </div>
      </div>
    </div>
  </div>
  </div>
  <ng-template #ticketLevel>
    <div class="col-12">
    <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-between align-items-center pl-3 pb-4 rr-container-white">
      <div class="d-flex flex-wrap flex-column flex-sm-row align-items-center">
        <div class="btn-group" role="button">
          <button class="btn fw-700 btn-primary" type="button">
            Daily
          </button>
          <button class="btn fw-700 btn-outline-secondary" type="button" (click)="navigateToBulk()">Bulk Edit</button>
        </div>
      </div>
    </div>
  </div>
  </ng-template>-->

  <!--Daily view-->
  <div *ngIf="ticketView == 'daily' && !entryDate">
    <datasheet-calendar [changeTicketView]="changeTicketView" [ticketView]="ticketView" [updateQueryParams]="updateQueryParams"></datasheet-calendar>
  </div>

  <!--Monthly view-->
  <div *ngIf="ticketView == 'bulk'">
    <app-view-datasheet [isMonthlyView]="isMonthlyView" [receivedDataSheets]="receivedDataSheets" [defaultStartDate]="startDate" [updateQueryParams]="updateQueryParams"></app-view-datasheet>
  </div>
</div>
